<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <h4>Mağaza Aylık Fatura Tutarları - Detay Rapor</h4>
        <p style="color: #6c757d">
          Fatura tutarını oluşturan siparişlerin detaylı listesi
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" sm="4" v-if="isAdmin">
        <v-autocomplete
          :items="allVenueNameList"
          item-text="venueName"
          item-value="id"
          v-model="venueIds"
          label="Mağaza Adı"
          data-vv-name="select"
          required
          multiple
          chips
          clearable
          :search-input.sync="venueSearch"
          @input="onVenueChange"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <v-autocomplete
          :items="allInvoicePeriods"
          item-text="text"
          v-model="invoicePeriods"
          item-value="value"
          label="Dönem Seçimi"
          data-vv-name="select"
          required
          multiple
          chips
          clearable
          searchable
          @change="onInvoicePeriodChange"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="12"
        sm="12"
        style="
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
        "
      >
        <v-btn
          color="#4d48f9"
          style="text-transform: none !important; color: white"
          @click="searchFilter()"
        >
          <v-icon style="font-size: 17px" color="white"> search </v-icon>
          Ara
        </v-btn>
        <v-btn
          depressed
          @click="clearSearch()"
          style="
            text-transform: none !important;
            float: left;
            color: white;
            background: white;
            color: #6c757d;
            border: 1px solid #dee2e6;
            cursor: pointer;
          "
        >
          <v-icon style="font-size: 17px" color="#6c757d">delete</v-icon>
          Filtreleri Temizle
        </v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        <p style="color: #6c757d; font-size: 14px; font-weight: 400">
          Toplam
          <strong style="color: black">{{ pagination.totalItems }}</strong>
          Kayıt Bulundu
        </p>
        <v-spacer></v-spacer>
        <div style="display: flex; flex-direction: column; gap: 10px">
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              justify-content: flex-end;
            "
          >
            <v-btn
              depressed
              :disabled="loading"
              :loading="loading"
              @click="exportReports('excel')"
              style="
                text-transform: none !important;
                float: left;
                color: white;
                background: white;
                color: #6c757d;
                border: 1px solid #dee2e6;
                cursor: pointer;
              "
            >
              <v-icon style="font-size: 17px" color="#6c757d"
                >mdi-file-excel</v-icon
              >
              Excel İndir
            </v-btn>
            <v-btn
              depressed
              :disabled="loading"
              :loading="loading"
              @click="exportReports('csv')"
              style="
                text-transform: none !important;
                float: left;
                color: white;
                background: white;
                color: #6c757d;
                border: 1px solid #dee2e6;
                cursor: pointer;
              "
            >
              <v-icon style="font-size: 17px" color="#6c757d"
                >mdi-file-delimited</v-icon
              >
              CSV İndir
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="storeAccountingHeaders"
        :items="allStoreMonthlyInvoiceDetail"
        style="white-space: nowrap"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.amount="{ item }">
          <td class="text-start">{{ item.amount }} ₺</td>
        </template>
      </v-data-table>
      <div
        style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-right: 32px;
        "
      >
        <div style="display: flex; gap: 30px; padding: 8px">
          <strong>Toplam Tutar:</strong>
          <strong>{{ allStoreMonthlyInvoiceDetailTotalAmount }} ₺</strong>
        </div>
      </div>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="monthlyInvoiceDetailPageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
          :total-visible="10"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MonthlyInvoiceDetail",
  data: () => ({
    monthlyInvoiceDetailPageData: {
      pageNumber: 1,
      pageSize: 10,
      venueIds: [],
      invoicePeriods: [],
    },
    venueIds: [],
    invoicePeriods: [],
    isAdmin: false,
    initialPeriod: "",
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    storeAccountingHeaders: [
      {
        text: "Firma adı",
        value: "companyName",
        align: "start",
        sortable: false,
      },
      { text: "Sipariş No", value: "orderId", sortable: false },
      { text: "Ürün Adı", value: "productName", sortable: false },
      { text: "Tutar", value: "amount", sortable: false },
      { text: "Sipariş Tarihi", value: "orderDate", sortable: false },
      { text: "Fatura Dönemi", value: "invoicePeriod", sortable: false },
    ],
  }),
  watch: {
    "$route.query.page"(val) {
      const pageNumber = val ? Number(val) : 1;
      this.getPageNumber(pageNumber);
    },
  },
  computed: mapGetters([
    "allStoreMonthlyInvoiceDetail",
    "loading",
    "allVenueNameList",
    "allInvoicePeriods",
    "allStoreMonthlyInvoiceDetailTotalAmount",
  ]),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1;
    const initialPeriod = this.getInitialPeriod();
    this.monthlyInvoiceDetailPageData.pageNumber = Number(page);
    this.monthlyInvoiceDetailPageData.invoicePeriods = [initialPeriod];
    this.invoicePeriods = [initialPeriod];
    this.initialPeriod = initialPeriod;

    this.userRoles = JSON.parse(localStorage.getItem("userRoles"));
    if (
      this.userRoles.find((x) => x == "PanelUser") != null &&
      this.userRoles.find((x) => x == "PanelUser") != undefined
    ) {
      this.isAdmin = true;
    }

    this.getStoreMonthlyInvoiceDetail(this.monthlyInvoiceDetailPageData).then(
      (response) => {
        this.pagination.totalItems = response.totalCount;
        this.pagination.pagesLength = response.totalPages;
      },
    );
    this.getVenueNameList();
    this.getInvoicePeriods();
  },
  methods: {
    ...mapActions([
      "getStoreMonthlyInvoiceDetail",
      "getStoreMonthlyInvoiceDetailReports",
      "getVenueNameList",
      "getInvoicePeriods",
    ]),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.monthlyInvoiceDetailPageData.pageSize = val;
      this.monthlyInvoiceDetailPageData.pageNumber = 1;
      this.getStoreMonthlyInvoiceDetail(this.monthlyInvoiceDetailPageData).then(
        (res) => {
          this.pagination.pagesLength = res.totalPages;
        },
      );
    },
    searchFilter() {
      this.monthlyInvoiceDetailPageData.venueIds = this.venueIds;
      if (this.invoicePeriods.length > 0) {
        this.monthlyInvoiceDetailPageData.invoicePeriods = this.invoicePeriods;
      } else {
        this.monthlyInvoiceDetailPageData.invoicePeriods = [this.initialPeriod];
        this.invoicePeriods = [this.initialPeriod];
      }
      this.monthlyInvoiceDetailPageData.pageNumber = 1;

      this.getStoreMonthlyInvoiceDetail(this.monthlyInvoiceDetailPageData).then(
        (response) => {
          this.pagination.totalItems = response.totalCount;
          this.pagination.pagesLength = response.totalPages;
        },
      );
    },
    clearSearch() {
      this.monthlyInvoiceDetailPageData = {
        pageNumber: 1,
        pageSize: 10,
        venueIds: [],
        invoicePeriods: [],
      };
      this.venueIds = [];
      this.invoicePeriods = [this.initialPeriod];
      this.searchFilter();
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.monthlyInvoiceDetailPageData.pageNumber = val;
      if (val !== 1) {
        this.$router.push({ query: { page: val } });
      }
      this.getStoreMonthlyInvoiceDetail(this.monthlyInvoiceDetailPageData);
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return;
      this.$router.push({ path: this.$route.fullPath, query: { page: val } });
    },
    async exportReports(type, useFilters = true) {
      let result;
      if (useFilters) {
        result = await this.getStoreMonthlyInvoiceDetailReports({
          pageNumber: this.monthlyInvoiceDetailPageData.pageNumber,
          pageSize: this.monthlyInvoiceDetailPageData.pageSize,
          venueIds: this.monthlyInvoiceDetailPageData.venueIds,
          invoicePeriods: this.monthlyInvoiceDetailPageData.invoicePeriods,
          type: type,
        });
      } else {
        result = await this.getStoreMonthlyInvoiceDetailReports({
          type: type,
        });
      }
      if (result.status != 200)
        this.$toasted.show(
          result.data.friendlyMessage.message || "Hata Oluştu.",
          {
            duration: 3000,
            position: "top-right",
            type: "error",
          },
        );
      else {
        this.$toasted.show("Rapor İndirme Başarılı", {
          duration: 3000,
          position: "top-right",
          type: "success",
        });
      }
    },
    onVenueChange(selectedIds) {
      this.venueIds = selectedIds;
    },
    onInvoicePeriodChange(selectedIds) {
      this.invoicePeriods = selectedIds;
    },
    getInitialPeriod() {
      const now = new Date();
      const initialDate = new Date(now);
      initialDate.setMonth(now.getMonth() - 1);

      const year = initialDate.getFullYear();
      const month = String(initialDate.getMonth() + 1).padStart(2, "0");
      return `${year}-${month}`;
    },
  },
};
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}

.v-data-footer__icons-after {
  display: none;
}
.address-area {
  max-width: 200px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.badge-active {
  background-color: #e6f7f0;
  color: #2e7d32;
}
.badge-passive {
  background-color: #fdecea;
  color: #c62828;
}
</style>
